import { message } from 'antd';
import moment from 'moment';
import { getMatchReport } from 'api/events';

export const downloadMatchReport = async ({ id, name, date_time, home, visit, place_name }) => {
  try {
    const response = await getMatchReport(id);
    const downloadUrl = window.URL.createObjectURL(new Blob([response.body]));
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute(
      'download',
      `${place_name?.replace(/\s/g, '')}_${name.replace(/\s/g, '')}_${home?.name?.replace(
        /\s/g,
        '',
      )}_VS_${visit?.name?.replace(/\s/g, '')}_${moment(date_time).format('YYYY-MM-DDTHH:mm')}.pdf`,
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    message.error('¡Ha Ocurrido un error! ¡Intenta nuevamente!');
  }
};
